import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { viewRole, toggleRole } from '~/services/api'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import moment from 'moment'
import $ from 'jquery'
import * as modules from '~/helper/constant/modules'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    role: Array,
    data: Array,
    loading: Boolean,
}

export class AbstractRoleViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            role: [
                {
                    name: {
                        field: 'text',
                        translate: "users:role.roleLabel",
                        route: false,
                        sortable: true,
                    },
                    access: {
                        field: 'badge',
                        translate: "users:role.access",
                        route: false,
                        sortable: false,
                    },
                    status: {
                        field: 'badge',
                        translate: "status",
                        route: false,
                        sortable: true,
                    },
                    action: {
                        field: 'button',
                        translate: "users:role.action",
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this._handleChange = this._handleChange.bind(this)
        this.toggle = this.toggle.bind(this)
    }

    componentDidMount() {
        this.loadCategory()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    toggle(e) {
        const link = e.target.getAttribute('link')
        $('#close_' + link).trigger('click')
        toggleRole(link, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadCategory()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    loadCategory() {
        this._handleChange('loading', true)
        viewRole(this.props.token).then((response) => {
            this._handleChange('loading', false)
            let role = []
            role.push(this.state.role[0])
            let dataList = []

            if (response.code == API_SUCCESS) {
                response.data.role.map((item, index) => {
                    const data = item
                    let access_data = []
                    let text = null
                    data.access.map((item, index) => {
                        modules.all_access
                            .filter((data) => data.value == item)
                            .map((data) => {
                                access_data.push(data.label)
                            })
                    })
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            translate: "statusActive",
                            badge: 'table-green',
                            modal: 'modal_role_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            translate: "statusInactive",
                            badge: 'table-red',
                            modal: 'modal_role_' + index,
                        }
                    }
                    const tableData = {
                        name: {
                            text: data.name,
                        },
                        access: {
                            text: access_data,
                            badge: 'table-grey',
                        },
                        status: text,
                        action: {
                            text: 'Edit',
                            translate: "EditBtn",
                            route: route.admin.user.role.edit + '/' + data.id,
                        },
                    }
                    dataList.push(data)
                    role.push(tableData)
                })
            }
            this.setState({
                data: dataList,
                role,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
